import { render, staticRenderFns } from "./GDQSettings.vue?vue&type=template&id=3eb42c25&"
import script from "./GDQSettings.vue?vue&type=script&lang=js&"
export * from "./GDQSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports